import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/home',
			name: 'home',
			component: () => import('@/views/Home.vue'),
		},

		{
			path: '/checkout',
			name: 'Checkout',
			component: () => import('@/views/Checkout.vue'),
		},
		{
			path: '/payment',
			name: 'Payment',
			component: () => import('@/views/Payment.vue'),
		},
		{
			path: '/',
			name: 'Landing',
			component: () => import('@/views/Landing/Index.vue'),
		},
		{
			path: '/thank-you-book-3',
			name: 'ThanksBook3',
			component: () => import('@/views/Landing/ThanksBook3.vue'),
		},

		{
			path: '/thank-you-book-5',
			name: 'ThanksBook5',
			component: () => import('@/views/Landing/ThanksBook5.vue'),
		},
		{
			path: '/thank-you-book',
			name: 'ThanksBook',
			component: () => import('@/views/Landing/ThanksBook.vue'),
		},

		// {
		// 	path: '/webinar-3',
		// 	name: 'Webinar3',
		// 	component: () => import('@/views/Landing/Webinar3.vue'),
		// },

		// {
		// 	path: '/webinar-3-tnx',
		// 	name: 'Webinar3Thanks',
		// 	component: () => import('@/views/Landing/Webinar3Thanks.vue'),
		// },

		{
			path: '/webinar-5',
			name: 'Webinar5',
			component: () => import('@/views/Landing/Webinar5.vue'),
		},

		{
			path: '/webinar-5-tnx',
			name: 'Webinar5Thanks',
			component: () => import('@/views/Landing/Webinar5Thanks.vue'),
		},
		{
			path: '/accessibility',
			name: 'Accessibility',
			component: () => import('@/views/Accessibility.vue'),
		},
		{
			path: '/terms',
			name: 'Terms',
			component: () => import('@/views/Terms.vue'),
		},
		{
			// Always last route
			path: '/:catchAll(.*)*',
			name: '404',
			component: async () => import('@/views/404.vue'),
		},
	],
	scrollBehavior(to) {
		if (to.hash) {
			return {
				behavior: 'smooth',
				el: to.hash,
				offset: { top: 0, left: 0 },
			}
		}
		return { top: 0, left: 0 }
	},
})

router.onError((error, to) => {
	if (error.message.includes('Failed to fetch dynamically imported module')) {
		Object.assign(window, { location: to.fullPath })
	}
})

export default router
